import React, { useState, FC, MouseEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import cls from 'classnames';

import { INavItem } from 'src/prize/types/shoppe';

import { Link } from '../../atoms/Link';
import { Dropdown } from './molecules/Dropdown';

import styles from './index.module.sass';

interface IMenuProps {
  className?: {
    dropdown?: string;
    link?: string;
  };
  data: INavItem;
}

export const Menu: FC<IMenuProps> = ({ className, data }) => {
  const [ toggled, setToggled ] = useState( false );

  const handleClick = ( event: MouseEvent<HTMLButtonElement> ) => {
    event.preventDefault();

    setToggled(( state ) => !state );
  };

  return (
    <>
      <Link className={cls( styles.link, className?.link )} href={data.url}>
        <span>{data.title}</span>

        <button className={styles.toggle} type="button" onClick={handleClick}>
          <FontAwesomeIcon
            className={cls( styles.icon, { [styles.toggled]: toggled })}
            icon={faCaretRight}
          />
        </button>
      </Link>

      <Dropdown className={className?.dropdown} isExpanded={toggled} links={data.children} />
    </>
  );
};
